import { BaseSuggestedRouteProps } from '@lp/features/MultiSuggest';
import { ConvertedRouteType } from '@lp/features/RoutePlanner/hooks/useConvertedRoute';
import { CurrentRouteSchema } from './CurrentRouteSchema';
import { SuggestedRouteSchema } from './SuggestedRouteSchema';

type CompareRouteSchemaViewProps = BaseSuggestedRouteProps & {
  route: Pick<ConvertedRouteType, 'segments' | 'legs'>;
};

export const CompareRouteSchemaView = ({ taskId, chainNumber, route }: CompareRouteSchemaViewProps) => (
  <div className="flex flex-col w-full">
    <CurrentRouteSchema segments={route.segments} legs={route.legs} />
    <SuggestedRouteSchema taskId={taskId} chainNumber={chainNumber} />
  </div>
);
